/* Atelier Noir — cinematic hero: lazy, connection-aware background video that
   crossfades over the LCP poster. Poster-only under reduced motion / save-data
   / 2g, and pauses off-screen or when the tab is hidden. */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)');

  class HeroCinema extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.hero-cinema__video');
      if (!this.video) return;
      const boot = () =>
        'requestIdleCallback' in window
          ? requestIdleCallback(() => this.start(), { timeout: 1200 })
          : setTimeout(() => this.start(), 200);
      if (document.readyState === 'complete') boot();
      else addEventListener('load', boot, { once: true });
    }

    start() {
      const c = navigator.connection || {};
      if (RM.matches || c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) {
        this.video.remove();
        this.video = null;
        return;
      }
      this.video.src = matchMedia('(min-width: 750px)').matches
        ? this.dataset.desktop
        : this.dataset.mobile;
      this.video.addEventListener(
        'canplay',
        () => {
          this.classList.add('is-playing');
          this.play();
        },
        { once: true }
      );
      this.video.load();

      this._vis = () => (document.hidden ? this.video.pause() : this.play());
      document.addEventListener('visibilitychange', this._vis);

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(
          (e) => (e[0].isIntersecting ? this.play() : this.video && this.video.pause()),
          { threshold: 0 }
        );
        this._io.observe(this);
      }
    }

    play() {
      if (this.video) this.video.play().catch(() => {});
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this._vis);
      if (this._io) this._io.disconnect();
    }
  }

  if (!customElements.get('hero-cinema')) customElements.define('hero-cinema', HeroCinema);
})();
